import React from 'react';
import type { CustomFilterMainCreatorProps } from '@/app/common/filters/core/filterComponentType.ts';
import { FilterRadio } from '@/app/common/filters/types/radio/FilterRadio.tsx';
import RankingBox from '@/app/components/search/components/Title/RankingBox/index.tsx';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { Separator } from '@/app/common/filters/surfaces/styled.ts';

const SortFilterRadio = ({ filter, columns, isLoading, handleFilterChanged }: CustomFilterMainCreatorProps) => {
  const { localization } = usePageWrapperData();

  return (
    <>
      <FilterRadio filter={filter} columns={columns} isLoading={isLoading} handleFilterChanged={handleFilterChanged} />
      {localization.rankingLink && (
        <>
          <Separator />
          <RankingBox localization={localization} variant="evolution" />
        </>
      )}
    </>
  );
};

export default SortFilterRadio;
